/* Switch the header once the top image has left the top of the screen.
   Home uses the slideshow. Process, How it works, and About use their own hero. */
(function () {
  var tries = 0;

  function hero() {
    return document.querySelector(
      [
        "#leaves-home [data-section-id='leaves-74fc']",
        "#leaves-home [data-section-id='leaves-1af2']",
        "#leaves-home [data-section-id='leaves-e708']",
        "#leaves-home [data-section-id='leaves-80a0']",
        '.leaves-process-hero',
        '.leaves-hiw-hero',
        '.leaves-about-hero',
        '.leaves-contact-hero',
        '[data-section-id="install-hero"]',
        '[data-section-id="hiw-hero"]',
      ].join(', ')
    );
  }

  function watch(node) {
    var frame = 0;

    function update() {
      frame = 0;
      var bottom = node.getBoundingClientRect().bottom;
      document.body.classList.toggle('is-past-hero', bottom <= 50);
    }

    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function start() {
    var node = hero();
    if (node) {
      watch(node);
      return;
    }
    tries += 1;
    if (tries < 40) {
      window.setTimeout(start, 80);
      return;
    }
    // No hero on this page — use the solid white bar so nav text stays readable.
    document.body.classList.add('is-past-hero');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
